import ApiService from '@/services/ApiService'
import Publisher from '@/models/Publisher'
import ListRequest from '@/models/requests/ListRequest'
import PaginationModel from '@/models/PaginationModel'

export default class PublisherService {
  public static async create(publisher: Partial<Publisher>): Promise<Publisher> {
    return ApiService.post<Publisher>(`publishers`, publisher)
  }

  public static async delete(id: string): Promise<void> {
    return ApiService.delete<void>(`publishers/${id}`)
  }

  public static async get(id: string): Promise<Publisher> {
    return ApiService.get<Publisher>(`publishers/${id}`)
  }

  public static async list(queryParams: ListRequest): Promise<PaginationModel<Publisher>> {
    return ApiService.get<PaginationModel<Publisher>>(`publishers`, queryParams)
  }

  public static async update(publisher: Partial<Publisher>): Promise<Publisher> {
    return ApiService.put<Publisher>(`publishers/${publisher.id}`, publisher)
  }
}
